<template>
  <el-dialog
    class="radish-dia"
    title="请填写公司部门"
    top="70px"
    width="300px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="radish-dia-body">
      公司:
      <el-autocomplete
        v-model="company"
        class="inline-input"
        :fetch-suggestions="searchCompany"
        placeholder="请输入内容"
        :trigger-on-focus="false"
      ></el-autocomplete>
      部门:
      <el-autocomplete
        v-model="department"
        class="inline-input"
        :fetch-suggestions="searchDepartment"
        placeholder="请输入内容"
        :trigger-on-focus="false"
      ></el-autocomplete>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      company: '',
      department: '',
    }
  },
  methods: {
    show: function(company, department) {
      this.company = company
      this.department = department
      this.dialogVisible = true
    },
    async handleConfirm() {
      if (!this.company || !this.department) {
        return this.message('请填写公司部门')
      }
      await this.onConfirm(this.company, this.department)
      this.dialogVisible = false
    },
    async searchCompany(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let results = []
      const res = await app.service('company').completeCompanyName(queryString)
      if (res.status === 'success') {
        results = res.data.map(c => ({ value: c.简称 }))
      }
      cb(results)
    },
    async searchDepartment(queryString, cb) {
      if (!queryString || !this.company) {
        cb([])
        return
      }
      let results = []
      const res = await app.service('company').completeDepartmentName({ 公司: this.company, 部门: queryString })
      if (res.status === 'success') {
        results = res.data.map(d => ({ value: d }))
      }
      cb(results)
    },
  },
}
</script>
